const colourGroups: {
  primary: ('primary1' | 'primary2' | 'primaryText' | 'primaryText2')[];
  secondary: ('secondary1' | 'secondary2' | 'secondaryText' | 'secondaryText2')[];
  tertiary: ('tertiary1' | 'tertiary2')[];
  base1colour: ('base1Colour1' | 'base1Colour2' | 'base1ColourText' | 'base1ColourText2')[];
  base2colour: ('base2Colour1' | 'base2Colour2' | 'base2ColourText' | 'base2ColourText2')[];

  scrollbar: 'scrollbarThumbColour'[];
} = {
  primary: ['primary1', 'primary2', 'primaryText', 'primaryText2'],
  secondary: ['secondary1', 'secondary2', 'secondaryText', 'secondaryText2'],
  tertiary: ['tertiary1', 'tertiary2'],
  base1colour: ['base1Colour1', 'base1Colour2', 'base1ColourText', 'base1ColourText2'],
  base2colour: ['base2Colour1', 'base2Colour2', 'base2ColourText', 'base2ColourText2'],
  scrollbar: ['scrollbarThumbColour'],
};

const colours = Object.values(colourGroups).flat();

export { colourGroups, colours };
